import { useRef } from 'react';
import styled from 'styled-components';

export default function TextInput(props) {
	const { value, setValue, placeholder } = props;

	const inputRef = useRef();

	function onClickInput(e) {
	}

	function onChangeInput(e) {
		setValue(e.target.value);
	}

	function onFocusInput(e) {
	}

	function onBlurInput(e) {
	}

	return <Input
		ref={inputRef}
		placeholder={placeholder}
		value={value}
		onClick={onClickInput}
		onChange={onChangeInput}
		onFocus={onFocusInput}
		onBlur={onBlurInput} />
}

const Input = styled.input`
	padding: 0 10px;
	
	box-sizing: border-box;
  width: 100%;
  height: 35px;
	// margin-top: 8px;

	outline: none;
	border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
	color: ${props => props.theme.text};
	background-color: ${props => props.theme.subBackground};

	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	::placeholder {
		color: ${props => props.theme.gray};
	}
	
  transition: all 0.5s ease-in-out;
`;